export default function () {
  const widgetName = 'multiScheduleFeature';
  const widgetOpts = multiScheduleFeatureOpts;

  $(`#${widgetName}`).append('<div class="multiFeatureContent"></div>');

  function setCharLimit(el, limit) {
    const text = el.text();
    return text.length > limit ? `${text.substring(0, limit)}...` : text;
  }

  function formatDate(el) {
    const datesMonth = el.text().slice(0, 3);
    const datesDay = el.text().slice(4, 7).replace(',', '');
    el.html(`<span>${datesMonth}</span><span>${datesDay}</span>`);
  }

  $(`#${widgetName}`).MultiScheduleFeature({
    scriptPath: widgetOpts.scriptPath,
    currentWidgetModuleItemID: widgetOpts.WidgetModuleDataItemID,
    detectIpad: IPADDETECTED,
    isResponsive: false,
    // options
    allEventsLink: true,
    allEventsLinkText: 'View all events',
    hasImages: false,
    imageBackground: false,
    lazyLoadImages: true,
    buyNowButton: { visible: false, text: 'BUY NOW' },
    moreButton: { visible: false, text: 'MORE' },
    maxItemsVisible: 4,
    hasDescription: false,
    textContainer: true,
    link: 'all', // options are 'all', 'text', 'image', 'imageAndText', or ''
    attributeOrder: {
      1: 'image',
      2: 'title',
      3: 'date',
      4: 'description',
      5: 'buttons',
    },
    multiFeatureLoaded: function (data) {
      if (data.length < 1) {
        $(`#${widgetName}`).remove();
      } else {
        $(`#${widgetName} .all-events-btn`).addClass('button');
        $(`#${widgetName} .featureItem`).each(function (i) {
          // if this href attribute is empty, remove the link
          $(this).attr('href') === '' ? $(this).removeAttr('href') : null;

          // const itemTitle = $(this).find('.featureItemTitle');
          $(this).find('.featureItemDescription').remove();
          /* uncomment below if you need to slice the date string up into something shorter like "Oct 31" */
          const eventDate = $(this).find('.featureItemDate');
          formatDate(eventDate);
          /* uncomment below if you need to limit the characters in the title or description text */
          $(
            this
          ).append(`<svg xmlns="http://www.w3.org/2000/svg" width="18" height="15" viewBox="0 0 18 15">
  <path class="cls-1" d="M2561,994h8v-5l9,7-9,8v-5h-8a2.76,2.76,0,0,1-1-2A8.021,8.021,0,0,1,2561,994Z" transform="translate(-2560 -989)"/>
</svg>`);
          /* uncomment below if 'more' text is needed after event description */
          // itemDescripton.append("<span class='more-text'>More</span>");
        });
      }
    },
  });
}

// helper functions
